import * as CubeTree from '../../cubeTree/index';
import * as StageStatus from '../../stageStatus/index';
import Utils from '../../utils/util';
import Config from '../../config/index';

function makeAddTaskQueue(copyData: FreeObjMap): Array<AddTask> {
    let taskList: Array<AddTask> = [];

    copyData.data.forEach((dataItem: FreeObjMap): void => {
        let cubeDataCopy: FreeObjMap = Utils.deepCopy(dataItem.cubeCopyData);
        let diffBusiness: boolean = isDiffBusiness(copyData.extendParams.venderId);

        // 清空坐标字段值
        clearPositionKey(cubeDataCopy);

        // 合法性校验
        if (!isValidate(cubeDataCopy)) {
            return;
        }

        let type: AddType = getAddType(cubeDataCopy);
        let task: AddTask = {
            cubeData: cubeDataCopy,
            type: type,
            extendParams: {
                addType: 'copy',
                diffBusiness: diffBusiness,
                originalCubePhysicsCoordinate: dataItem.extendParams.originalCubePhysicsCoordinate,
                spaceHeightUsed: dataItem.extendParams.spaceHeightUsed
            }
        };

        taskList.push(task);
    });

    return taskList;
}

function isValidate(cubeDataCopy: FreeObjMap): boolean {
    // 卧柜
    if (StageStatus.isTopFace()) {
        return CubeTree.isFreezerCubeData(cubeDataCopy)
            || CubeTree.isCabinetCubeData(cubeDataCopy)
            || CubeTree.isTextareaCubeData(cubeDataCopy)
            || CubeTree.isGoodsCubeData(cubeDataCopy);
    }

    return CubeTree.isShelfCubeData(cubeDataCopy)
        || CubeTree.isDishrackCubeData(cubeDataCopy)
        || CubeTree.isBeamCubeData(cubeDataCopy)
        || CubeTree.isRoofCubeData(cubeDataCopy)
        || CubeTree.isLayerCubeData(cubeDataCopy)
        || CubeTree.isTextareaCubeData(cubeDataCopy)
        || CubeTree.isBafflePlateCubeData(cubeDataCopy)
        || CubeTree.isGoodsCubeData(cubeDataCopy);
}

function getAddType(cubeDataCopy: FreeObjMap): AddType {
    let type: AddType;

    if (CubeTree.isShelfCubeData(cubeDataCopy)
        || CubeTree.isFreezerCubeData(cubeDataCopy)) {
        type = 'shelf';
    }
    else if (CubeTree.isPartitionCubeData(cubeDataCopy)) {
        type = 'partition';
    }
    else if (CubeTree.isGoodsCubeData(cubeDataCopy)) {
        type = 'goods';
    }
    else if (CubeTree.isTextareaCubeData(cubeDataCopy)) {
        type = 'textarea';
    }
    else if (CubeTree.isBafflePlateCubeData(cubeDataCopy)) {
        type = 'bafflePlate';
    }

    return type;
}

// 清空坐标字段值
function clearPositionKey(cubeCopyData: FreeObjMap): void {
    if (!Utils.isExist(cubeCopyData)) {
        return;
    }

    let posxKey: string = '';
    let posyKey: string = '';

    if (CubeTree.isGoodsCubeData(cubeCopyData)
        || CubeTree.isBafflePlateCubeData(cubeCopyData)
        || CubeTree.isTextareaCubeData(cubeCopyData)) {
        posxKey = Config.get({
            moduleName: 'goods',
            key: 'keyMap.posX'
        });
        posyKey = Config.get({
            moduleName: 'goods',
            key: 'keyMap.posY'
        });
    }
    else if (CubeTree.isPartitionCubeData(cubeCopyData)) {
        posxKey = Config.get({
            moduleName: 'layer',
            key: 'keyMap.posX'
        });
        posyKey = Config.get({
            moduleName: 'layer',
            key: 'keyMap.posY'
        });
    }

    Utils.setMapValueByStringKey(cubeCopyData, posxKey, 0);
    Utils.setMapValueByStringKey(cubeCopyData, posyKey, 0);
}

function isDiffBusiness(copyVenderId: number): boolean {
    let venderIdNow: number = Config.get({
        moduleName: 'base',
        key: 'venderId'
    });

    return venderIdNow !== copyVenderId;
}

/**
 * @description: 获取已复制的cubeId数组
 * @param {FreeObjMap} cubeCopyData 
 * @return {Array} cubeIds[]
 */
function getCopyCubeIds(cubeCopyData:FreeObjMap): CubeId[] {
    const cubeIds:CubeId[] = [];

    cubeCopyData.data.forEach((cubeData: Cube) => {
        const shelfId = cubeData.cubeCopyData.id;

        if (shelfId) {
            cubeIds.push(shelfId);
        }
    });
    
    return cubeIds;
}

export {
    makeAddTaskQueue,
    isDiffBusiness,
    getCopyCubeIds
};
